import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import RcTooltip from "rc-tooltip";
import 'rc-tooltip/assets/bootstrap_white.css';

var placementEnum = {
  bottomLeft: {
    points: ['tr', 'tl'],
    offset: [0, 20],
    targetOffset: [0, '-100%'],
    overflow: {
      adjustX: true,
      adjustY: true
    }
  },
  bottomRight: {
    points: ['tl', 'tr'],
    offset: [0, 20],
    targetOffset: [0, '-100%'],
    overflow: {
      adjustX: true,
      adjustY: true
    }
  },
  topLeft: {
    points: ['br', 'bl'],
    offset: [0, -20],
    targetOffset: [0, '100%'],
    overflow: {
      adjustX: true,
      adjustY: true
    }
  },
  topRight: {
    points: ['bl', 'br'],
    offset: [0, -20],
    targetOffset: [0, '100%'],
    overflow: {
      adjustX: true,
      adjustY: true
    }
  }
};

var Tooltip = function Tooltip(props) {
  var color = props.color,
      overlayInnerStyle = props.overlayInnerStyle,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottomRight' : _props$placement,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'hover' : _props$trigger;
  var formattedOverlayInnerStyle = props.overlayInnerStyle;

  if (color) {
    formattedOverlayInnerStyle = _objectSpread(_objectSpread({}, overlayInnerStyle), {}, {
      background: color
    });
  }

  var arrowContentStyle = {
    background: color
  };
  return /*#__PURE__*/React.createElement(RcTooltip, {
    overlayClassName: 'sfx-react-ui-tooltip',
    placement: props.placement,
    align: placementEnum[placement],
    trigger: trigger,
    overlay: props.content || props.title,
    overlayStyle: {
      color: color
    },
    destroyTooltipOnHide: true,
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.2,
    overlayInnerStyle: formattedOverlayInnerStyle,
    arrowContent: /*#__PURE__*/React.createElement("span", {
      className: "sfx-react-ui-tooltip-arrow-content",
      style: arrowContentStyle
    })
  }, props.children);
};

export default Tooltip;